import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

/**
 * Prevent calling handlers if button has aria-disabled="true"
 */
export function ariaDisabledGuard([handler]) {
  assert(
    `Expected '${handler}' to be a function, if present.`,
    !handler || typeof handler === 'function'
  );

  return function (event) {
    assert(`Expected '${event}' to be an Event instance`, event instanceof Event);

    let button =
      event.type === 'submit'
        ? (event.submitter ?? event.target.querySelector('[type=submit]'))
        : event.currentTarget;

    if (button?.ariaDisabled !== 'true') handler?.(event);
  };
}

export default helper(ariaDisabledGuard);
